// pagarme.js

import axios from "axios";

const pagarmeInstance = axios.create({
   baseURL: process.env.VUE_APP_PAGARME_PUBLIC_URL
});

export default pagarmeInstance;
